import Vue from 'vue'
import App from './App.vue'
import { router } from "./_helpers";
import { store } from "./_store";
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import axios from 'axios'

Vue.config.productionTip = false
Vue.use(BootstrapVue);

// *******************
// axios Configure
// *******************
axios.interceptors.request.use(config => {
  config.headers.CacheControl = 'no-cache'
  config.headers.pragma = 'no-cache'
  config.headers.expires = -1
  return config
})

axios.interceptors.response.use(config => {
  config.headers.CacheControl = 'no-cache'
  config.headers.pragma = 'no-cache'
  config.headers.expires = -1
  return config
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
